import { ANIMATION_STATUS } from '../../animation.constants';
import { getTransitionPropsWithDefaults } from '../../services/animation';
import { BLUR_IN_TRANSITION, BLUR_OUT_TRANSITION, HEIGHT_TRANSITION } from '../../types/animation.types';
var ANIMATING = ANIMATION_STATUS.ANIMATING;
export function getStylesForTransitionProps(transition, status) {
  var transitionProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var props = getTransitionPropsWithDefaults(transition, transitionProps[status] || {});
  if (transition === BLUR_OUT_TRANSITION) {
    if (status === ANIMATING) {
      return {
        opacity: +props.opacity,
        filter: "blur(".concat(props.blur, ")")
      };
    }
  }
  if (transition === BLUR_IN_TRANSITION) {
    if (status === ANIMATING) {
      return {
        opacity: +props.opacity,
        filter: "blur(".concat(props.blur, ")")
      };
    }
  }
  if (transition === HEIGHT_TRANSITION) {
    return {
      height: props.height,
      overflow: props.overflow
    };
  }
  return {};
}
export function getTransition(duration, easing) {
  var transition = "all ".concat(duration, "ms ").concat(easing);
  if (duration === 0) {
    transition = 'none';
  }
  return transition;
}